import { motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function TermsPage() {
  // Check if user is B2B (from localStorage)
  const isB2B = localStorage.getItem("cliptour_isB2B") === "true";
  const homePath = isB2B ? "/partners" : "/";
  
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Header homePath={homePath} />

      <section className="section-spacing pt-32">
        <div className="container-custom">
          <motion.div 
            className="max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
            <p className="text-slate-500 mb-8">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>

            <div className="prose prose-slate max-w-none">
              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-600 mb-4">
                By accessing and using Cliptour's services at cliptour.ai, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">2. Services Description</h2>
              <p className="text-slate-600 mb-4">
                Cliptour provides video production services that transform property photos into marketing videos. Our services include:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Cliptour: Video production from furnished property photos</li>
                <li>Cliptour Staged: AI staging and video production from vacant property photos</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">3. Orders and Deliverables</h2>
              <p className="text-slate-600 mb-4">
                Each order includes:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Selection of the best 10 photos from your submitted materials</li>
                <li>10 individual video clips suitable for social media</li>
                <li>1 cinematic montage with music</li>
                <li>Delivery within 48 business hours</li>
                <li>White label option (your logo, no Cliptour branding)</li>
                <li>2 revisions included</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">4. Revisions Policy</h2>
              <p className="text-slate-600 mb-4">
                Each order includes 2 complimentary revisions. Additional revisions are available at $50 per revision. Revision requests must be submitted within 14 days of delivery.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">5. Payment and Refunds</h2>
              <p className="text-slate-600 mb-4">
                <strong>No Refunds Policy:</strong> Due to the custom nature of our work, all sales are final. We do not offer refunds once an order has been placed and work has begun.
              </p>
              <p className="text-slate-600 mb-4">
                However, we are committed to your satisfaction and will work with you until you are happy with the final product. This includes utilizing your included revisions and, if necessary, providing additional revisions at our discretion.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">6. Intellectual Property</h2>
              <p className="text-slate-600 mb-4">
                You retain ownership of the original photos you submit. Upon delivery and payment completion, you receive full rights to use the produced videos for marketing purposes. Cliptour retains the right to use anonymized samples in our portfolio unless otherwise agreed.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">7. Content Requirements</h2>
              <p className="text-slate-600 mb-4">
                By submitting photos to Cliptour, you represent and warrant that:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>You own or have the rights to use the submitted photos</li>
                <li>The photos do not infringe on any third-party rights</li>
                <li>The photos do not contain illegal or prohibited content</li>
              </ul>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">8. Limitation of Liability</h2>
              <p className="text-slate-600 mb-4">
                Cliptour shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our services. Our total liability shall not exceed the amount paid for the specific order in question.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">9. Modifications to Terms</h2>
              <p className="text-slate-600 mb-4">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
              </p>

              <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">10. Contact Information</h2>
              <p className="text-slate-600 mb-4">
                For questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-slate-600">
                Email: <a href="mailto:contact@cliptour.ai" className="text-#3C59B2 hover:underline">contact@cliptour.ai</a>
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
